import { mapActions, mapState } from 'vuex'

export default {
  async created() {
    await this.getPlans()
  },
  computed: {
    ...mapState({
      plans: ({ plans: { plans } }) => plans,
      automation_plans: ({ plans: { automation_plans } }) => automation_plans
    })
  },
  methods: {
    ...mapActions({
      getPlans: 'plans/getPlans'
    }),
    getPlanIdByName(name) {
      const matchingPlan = this.plans.find(plan => plan.name === name)
      return matchingPlan ? matchingPlan.id : null
    },
    getServiceType(service) {
      const TYPE = [
        null,
        'email',
        'whatsapp',
        'api_call_message',
        'sms',
        'query',
        'additional_user',
        'add_thousand_records',
        'gateway_fee'
      ]

      return TYPE[service.type] ? TYPE[service.type] : null
    }
  }
}
